export type ContractsIconProps = {
  accent?: 'currentColor' | ContractsIconAccentColors
}

export enum ContractsIconAccentColors {
  PRIMARY = '--bg-primary'
}
